import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ElementNameChange = ProjectChangeMap[ProjectChangeType.ElementName];

/**
 * Applies {@link ElementNameChange} to non-version elements (including product rows with optional name).
 *
 * @param element - Current element state
 * @param change - Name + fallback payload
 * @returns Partial patch or undefined when the target is a version root (use {@link ProjectChangeType.VersionName})
 */
export const elementNameToChange = (
  element: OneOfElements,
  change: ElementNameChange,
): Partial<OneOfElements> | undefined => {
  if (projectGuards.is.buildingVersion(element)) return undefined;

  return {
    name: change.name,
    fallbackName: change.fallbackName,
  };
};
